// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.common-cotent-container {
    padding: 5px 20px;
    height: 100%;
    background: var(--content-container-bg-light);
}

.common-save-btn {
    background-color: #157a3d;
}


.common-cancel-btn {
    background-color: var( --cancel-btn-bg-light);
    color:  var(  --cancel-btn-color-light);
    border: '1px solid rgba(0, 0, 0, 0.23)'
}

.common-btn-color {
    background-color: #157a3d;
}


@media (min-height: 900px) {
    .common-cotent-container {
        min-height: 740px /* Adjust maximum height for smaller screens */;
        height: 100%;
    }
}

@media (max-height: 900px) {
    .common-cotent-container {
        min-height: 640px /* Adjust maximum height for smaller screens */;
       
    }
}

`, "",{"version":3,"sources":["webpack://./src/styles/common.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,6CAA6C;IAC7C,uCAAuC;IACvC;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI;QACI,iEAAiE;QACjE,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,iEAAiE;;IAErE;AACJ","sourcesContent":["\r\n.common-cotent-container {\r\n    padding: 5px 20px;\r\n    height: 100%;\r\n    background: var(--content-container-bg-light);\r\n}\r\n\r\n.common-save-btn {\r\n    background-color: #157a3d;\r\n}\r\n\r\n\r\n.common-cancel-btn {\r\n    background-color: var( --cancel-btn-bg-light);\r\n    color:  var(  --cancel-btn-color-light);\r\n    border: '1px solid rgba(0, 0, 0, 0.23)'\r\n}\r\n\r\n.common-btn-color {\r\n    background-color: #157a3d;\r\n}\r\n\r\n\r\n@media (min-height: 900px) {\r\n    .common-cotent-container {\r\n        min-height: 740px /* Adjust maximum height for smaller screens */;\r\n        height: 100%;\r\n    }\r\n}\r\n\r\n@media (max-height: 900px) {\r\n    .common-cotent-container {\r\n        min-height: 640px /* Adjust maximum height for smaller screens */;\r\n       \r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
